import { MARQUES } from "@/lib/data";

export default function Marquee() {
  const items = [...MARQUES, ...MARQUES];
  return (
    <section aria-hidden="true" className="cd-marquee py-14 border-y border-black/10 overflow-hidden bg-[color:var(--cream)]" data-testid="marquee">
      <div className="cd-marquee-track flex gap-16 whitespace-nowrap">
        {items.map((m, i) => (
          <span key={i} className="font-serif italic text-[7vw] leading-none text-[color:var(--ink)]/85 tracking-tight">
            {m}<span className="mx-8 text-[color:var(--burgundy)]/70 not-italic">·</span>
          </span>
        ))}
      </div>
    </section>
  );
}
